module.exports = __webpack_public_path__ + "img/tapin_brand.56a2116a.jpg";